module.exports = __webpack_public_path__ + "static/media/line-solid.28a0a14e.svg";